import { render, staticRenderFns } from "./productsOpeningBalance.vue?vue&type=template&id=c00715dc"
import script from "./productsOpeningBalance.vue?vue&type=script&lang=js"
export * from "./productsOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./productsOpeningBalance.vue?vue&type=style&index=0&id=c00715dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports